import React from 'react';
import PropTypes from 'prop-types';
import TimelineLite from 'gsap/TimelineLite';
import api from "../../../general/js/api";
import axios from "axios";
import pageSpinner from "../../../general/js/page-spinner";
import contentBlocker from '../../../general/js/content-blocker';
import UrlHelper from "../../../general/js/url-helper";
import ListingLoadMore from "./ListingLoadMore";
import ListingControlsTrigger from "./ListingControlsTrigger";
import eventBus from '../../../general/js/event-bus';
import {EVENT_DEVICE_TYPE_CHANGED, DEVICE_TYPE_DESKTOP} from "../../../general/js/app";

export default class Listing extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            filters: {},
            pagination: {
                perPage: 0,
                totalCount: 0,
                currentPage: 0,
                pageCount: 0,
            },
            isControlsOpened: false,
            isControlsShowing: false,
            isLoadingMore: false,
            isInitialRequestFulfilled: false
        };

        this.currentPage = null;
        this.lastRequestCancel = null;
        this.isControlsOpened = false;

        this.onFiltersChange = this.onFiltersChange.bind(this);
        this.onLoadMore = this.onLoadMore.bind(this);
        this.onControlsTriggerClick = this.onControlsTriggerClick.bind(this);
        this.onControlsOverlayClick = this.onControlsOverlayClick.bind(this);
        this.animateChange = this.animateChange.bind(this);

        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged.bind(this));
    }

    onDeviceTypeChanged(oldType, newType) {
        //switch from tablet/mobile to desktop
        //we have to close controls
        if (newType == DEVICE_TYPE_DESKTOP) {
            this.closeControls();
        }
    }

    componentWillMount() {
        this.baseUrl = UrlHelper.getPathWithQueryString(window.location, Object.keys(this.props.defaultFilters));
        this.setFilters(this.getInitialFilters());
        window.addEventListener('popstate', this.onPopstate.bind(this));
    }

    animateChange(changeAction) {
        let content = this.element.querySelector('.listing__content');
        let timiline = new TimelineLite();
        timiline
            .to(content, 0.2, {
                opacity: 0, onComplete: () => {
                    if (changeAction) {
                        changeAction();
                    }
                }
            })
            .to(content, 0.4, {opacity: 1})
    }

    loadItems() {
        pageSpinner.show({fade: true});
        this.getItems().then(result => {
            this.animateChange(() => {
                this.setState({
                    items: result.items,
                    pagination: result.pagination,
                    isInitialRequestFulfilled: true,
                });
                this.currentPage = result.pagination.currentPage;
                pageSpinner.hide();
            });
        }, error => {
            //hide after error only when our request has been canceled
            if (!axios.isCancel(error)) {
                pageSpinner.hide();
            }
        });
    }

    loadNextPageItems() {
        if (!this.state.isLoadingMore) {
            this.setState({isLoadingMore: true}, () => {

                this.getItems(this.currentPage + 1).then(result => {
                    this.setState({
                        items: [...this.state.items, ...result.items],
                        pagination: result.pagination
                    });
                    this.currentPage = result.pagination.currentPage;
                }).finally(() => {
                    this.setState({
                        isLoadingMore: false
                    });
                });

            });
        }
    }

    setFilters(filters) {
        let newFilters = {...this.props.defaultFilters, ...filters};
        this.setState({filters: newFilters}, () => {
            this.loadItems();
        });
    }

    getInitialFilters() {
        return this.getFiltersByLocation(document.location);
    }

    onPopstate(e) {
        this.setFilters(this.getFiltersByLocation(document.location));
    }

    onFiltersChange(filterObject) {
        let passedFilters = this.getValidFilters(filterObject);
        let updatedFilters = {...this.state.filters, ...passedFilters};
        this.setFilters(updatedFilters);

        let url = this.baseUrl;
        let searchableFilters = UrlHelper.getSearchableParams(updatedFilters, this.props.defaultFilters);
        if (Object.keys(searchableFilters).length > 0) {
            url = UrlHelper.getUrlByParams(url, searchableFilters);
        }

        window.history.pushState(updatedFilters, '', url);
        this.closeControls();
    }

    onLoadMore() {
        this.loadNextPageItems();
    }

    getItems(page = 1) {
        let params = {...this.state.filters};
        params.page = page;

        if (this.lastRequestCancel) {
            this.lastRequestCancel('Request was canceled');
            this.lastRequestCancel = null;
        }

        let CancelToken = axios.CancelToken;
        let source = CancelToken.source();
        this.lastRequestCancel = source.cancel.bind(source);

        return api.get(this.props.options.endpointUrl, {
            params: params,
            cancelToken: source.token,
            headers: this.props.options.customHeaders ? this.props.options.customHeaders : {}
        }).then((result) => {
            this.lastRequestCancel = null;
            return result.data;
        }, (error) => {
            if (!axios.isCancel(error)) {
                this.lastRequestCancel = null;
            }
            return Promise.reject(error);
        });
    }

    getFiltersByLocation(location) {
        let search = UrlHelper.getSearchFromLocation(location);
        return this.getValidFilters(search);
    }

    getValidFilters(filters) {
        let result = {};
        for (let i in filters) {
            if (i in this.props.defaultFilters) {
                result[i] = filters[i];
            }
        }
        return result;
    }

    onControlsTriggerClick() {
        if (!this.isControlsInProgress) {
            this.isControlsInProgress = true;

            if (!this.state.isControlsOpened) {
                contentBlocker.block('listing-menu');
                this.setState({isControlsShowing: true}, () => {
                    setTimeout(() => {
                        this.setState({isControlsOpened: true}, () => {
                            this.isControlsInProgress = false;
                        });
                    }, 0);
                });
            } else {
                this.closeControls();
            }
        }
    }

    onControlsOverlayClick() {
        if (!this.isControlsInProgress && this.state.isControlsOpened) {
            this.closeControls();
        }
    }

    closeControls() {
        contentBlocker.unblock('listing-menu');
        this.setState({isControlsOpened: false}, () => {
            setTimeout(() => {
                this.setState({isControlsShowing: false}, () => {
                    this.isControlsInProgress = false;
                });
            }, 500);
        });
    }

    render() {
        return (
            <div ref={el => this.element = el}>
                {this.props.render({
                    isInitialRequestFulfilled: this.state.isInitialRequestFulfilled,
                    filters: this.state.filters,
                    items: this.state.items,
                    pagination: this.state.pagination,
                    onFiltersChange: this.onFiltersChange,
                    controls: {
                        isControlsOpened: this.state.isControlsOpened,
                        isControlsShowing: this.state.isControlsShowing,
                        onOverlayClick: this.onControlsOverlayClick,
                    },
                    animateChange: this.animateChange
                })}
                <ListingLoadMore onLoadMore={this.onLoadMore} pagination={this.state.pagination}
                                 isLoadingMore={this.state.isLoadingMore}/>
                <ListingControlsTrigger onClick={this.onControlsTriggerClick}
                                        isControlsOpened={this.state.isControlsOpened}/>
            </div>
        );
    }
}

Listing.propTypes = {
    options:PropTypes.object.isRequired,
    defaultFilters:PropTypes.object.isRequired,
    render: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/listing/js/Listing.js